import {ActionsEnum} from "@/entity/ActionsEnum";

export var menuItems = [
    {
        action: 'mdi-circle',
        title: 'Genel',
        active: true,
        items: [
            {
                title: 'Yorumlar' ,
                route:  '/genel/comments',
                action: ActionsEnum.Comments
            },
            {
                title: 'Sayfalar' ,
                route:  '/genel/pages',
                action: ActionsEnum.Pages
            },
            {
                title: 'Blog' ,
                route:  '/genel/blog',
                action: ActionsEnum.Blog
            },
            {
                title: 'Kullanıcılar' ,
                route:  '/genel/users',
                action: ActionsEnum.Users
            },
            {
                title: 'Bayiler' ,
                route:  '/genel/bayiler',
                action: ActionsEnum.Dealer
            },
        ],
    },
    {
        action: 'mdi-arrow-right',
        title: 'Kategori',
        items: [
            {
                title: 'Kategoriler' ,
                route: '/category/category',
                action: ActionsEnum.Categories
            },
            {
                title: 'Kategori görünüm' ,
                route: '/category/show',
                action: ActionsEnum.CategoryShow
            },
        ],
    },
    {
        action: 'mdi-arrow-right',
        title: 'Ürün ayarları',
        items: [
            {
                title: 'Ürünler' ,
                route: '/urunayarlari/urunler',
                action: ActionsEnum.Product
            },
            {
                title: 'Ürün varyasyon' ,
                route: '/urunayarlari/urunvaryasyon',
                action: ActionsEnum.ProductVariant
            },
        ],
    },
    {
        action: 'mdi-circle',
        title: 'Site Ayarları',
        active: false,
        items: [
            {
                title: 'Genel' ,
                route:  '/ayarlar/siteconfig',
                action: ActionsEnum.Config
            },
            {
                title: 'Slider' ,
                route:  '/ayarlar/slider',
                action: ActionsEnum.Slider
            },
            {
                title: 'Ödeme türleri' ,
                route:  '/ayarlar/paymenttypes',
                action: ActionsEnum.PaymentTypes
            },
            {
                title: 'Sanal POS Ayarları' ,
                route:  '/ayarlar/sanalpos',
                action: ActionsEnum.SanalPos
            },
            {
                title: 'Kurulumlar' ,
                route:  '/ayarlar/kurulumlar',
                action: ActionsEnum.Kurulum
            },
            {
                title: 'Havale bilgileri' ,
                route:  '/ayarlar/havalebilgileri',
                action: ActionsEnum.Config
            },
            {
                title: 'SMS Sablonları' ,
                route:  '/ayarlar/sablon',
                action: ActionsEnum.Sablon
            },
            {
                title: 'Sözleşmeler / Kurallar' ,
                route:  '/ayarlar/rules',
                action: ActionsEnum.Config
            },
            {
                title: 'Program Sözleşmeleri' ,
                route:  '/ayarlar/sozlesmeler',
                action: ActionsEnum.Sozlesme
            },
            {
                title: 'Sıkça Sorulan Sorular' ,
                route:  '/sss/sikcaSorulanSorular',
                action: ActionsEnum.Sss
            },
            {
                title: 'Kullanim Kılavuzu' ,
                route:  '/kk/kullanimKilavuzu',
                action: ActionsEnum.Kk
            },
            {
                title: 'Seo Ayarları' ,
                route:  '/ayarlar/seosettings',
                action: ActionsEnum.Seo
            },
        ],
    },
    {
        action: 'mdi-square',
        title: 'Kampanya',
        active: false,
        items: [


           {
                title: 'Kuponlar' ,
                route:  '/kampanya/coupon',
                action: ActionsEnum.Coupon
            },
            {
                title: 'İndirim' ,
                route:  '/kampanya/discount',
                action: ActionsEnum.Discount
            },
            {
                title: 'Kampanyalar' ,
                route:  '/kampanya/kampanyalar',
                action: ActionsEnum.Campaigns
            },

            {
                title: 'Splash (Popup)' ,
                route:  '/kampanya/splash',
                action: ActionsEnum.Config
            },
        ],
    },
    {
        action: 'mdi-basket',
        title: 'Sipariş',
        active: false,
        items: [
            {
                title: 'Sepet Oluştur',
                route:  '/siparis/sepetolustur',
                action: ActionsEnum.CreateOrder
            },
            {
                title: 'Gelen siparişler' ,
                route:  '/siparis/onaylananlar/2',
                action: ActionsEnum.Orders
            },
            {
                title: 'Hazırlanıyor' ,
                route:  '/siparis/hazirlanıyor/3',
                action: ActionsEnum.Orders
            },
            {
                title: 'Onay bekliyor' ,
                route:  '/siparis/onaybekliyor/1',
                action: ActionsEnum.Orders
            },
            {
                title: 'Tamamlanan Siparişler' ,
                route:  '/siparis/tamamnlananlar/7',
                action: ActionsEnum.Orders
            },
            {
                title: 'İptal edilenler' ,
                route:  '/siparis/iptaledilen/5',
                action: ActionsEnum.Orders
            },
            {
                title: 'Değişim talebi' ,
                route:  '/siparis/degisimtalebi/6',
                action: ActionsEnum.Orders
            },

            {
                title: 'İşlem görmemişler' ,
                route:  '/siparis/islemgormemisler/0',
                action: ActionsEnum.Orders
            },
            {
                title: 'Tüm siparişler' ,
                route:  '/siparis/tumsiparisler/all',
                action: ActionsEnum.Orders
            },
            /*
            {
                title: 'Son 1 haftaki siparişler' ,
                route:  '/siparis/sonhafta/lastweek',
                action: ActionsEnum.Orders
            },
             */
        ],
    },
    {
        action: 'mdi-account-tie',
        title: 'Yönetim',
        active: false,
        items: [
            {
                title: 'Loglar' ,
                route:  '/yonetim/logs',
                action: ActionsEnum.Logs
            },
            {
                title: 'Google UTM Verileri' ,
                route:  '/yonetim/googleutm',
                action: ActionsEnum.GoogleUtm
            },
            {
                title: 'Duyurular' ,
                route:  '/yonetim/duyurular',
                action: ActionsEnum.Duyurular
            },
            {
                title: 'Bilgilendirme' ,
                route:  '/yonetim/bilgilendirme',
                action: ActionsEnum.Bilgilendirme
            },
            {
                title: 'Cron İşleri' ,
                route:  '/yonetim/jobs',
                action: ActionsEnum.Jobs
            },
            {
                title: 'Tenant Havuzu' ,
                route:  '/yonetim/tenant-havuzu',
                action: ActionsEnum.TenantPool
            },
        ],
    },
    {
        action: 'mdi-account-multiple-outline',
        title: 'Kullanıcılar',
        active: false,
        items: [
            {
                title: 'Tüm kullanıcılar',
                route: '/kullanicilar/tum-kullanicilar',
                action: ActionsEnum.Customers
            },
            {
                title: 'Lisansi bitmis kullanicilar',
                route: '/kullanicilar/lisansi-bitmis-kullanicilar',
                action: ActionsEnum.Customers
            }
        ],
    },
    {
        action: 'mdi-poll',
        title: 'Anket & Değerlendirme',
        active: false,
        items: [
            {
                title: 'Değerlendirmeler',
                route: '/anket/degerlendirme',
                action: ActionsEnum.Survey
            },
            {
                title: 'Anket Ayarları',
                route: '/anket/anket-ayarlari',
                action: ActionsEnum.Survey
            }
        ],
    },
    {
        action: 'mdi-application-edit-outline',
        title: 'İcraproWeb',
        active: false,
        items: [
            {
                title: 'Hesaplar',
                route: '/icraproWeb/hesaplar',
                action: ActionsEnum.IcwHesaplar
            },
            {
                title: 'İcra Dairesi - Mahkeme',
                route: '/icraproWeb/icra-dairesi-mahkeme',
                action: ActionsEnum.IcwIcraDairesiMahkeme
            },
            {
                title: 'Noterler',
                route: '/icraproWeb/noterler',
                action: ActionsEnum.IcwNoterler
            },
            {
                title: 'Harçlar',
                route: '/icraproWeb/harclar',
                action: ActionsEnum.IcwHarclar
            },
            {//masraf çeşitleri
                title: 'Masraflar',
                route: '/icraproWeb/masraflar',
                action: ActionsEnum.IcwMasraflar
            },
            {
                title: 'Faizler',
                route: '/icraproWeb/faizler',
                action: ActionsEnum.IcwFaizler
            },
            {
                title: 'İhtiyati Haciz',
                route: '/icraproWeb/ihyitati-haciz',
                action: ActionsEnum.IcwIhtiyatiHaciz
            },
            {
                title: 'Bankalar',
                route: '/icraproWeb/banka',
                action: ActionsEnum.IcwBanka
            },
            {
                title: 'Yargı Birimi',
                route: '/icraproWeb/yargi-birimi',
                action: ActionsEnum.IcwYargiBirimi
            },
            {
                title: 'Loglar',
                route: '/icraproWeb/loglar',
                action: ActionsEnum.IcwLogs
            },
            {
                title: 'Gece Koşusu',
                route: '/icraproWeb/gece-kosusu',
                action: ActionsEnum.IcwGeceKosusu
            }
        ],
    },
    {
        action: 'mdi-scale-balance',
        title: 'Arabulucu',
        active: false,
        items: [
            /*{
                title: 'Arabuluculuk Bürosu',
                route: '/arabulucu/uyusmazlik-turleri',
                action: ActionsEnum.ArbUyusmazlikTurleri
            },*/
            {
                title: 'Uyuşmazlık Türleri',
                route: '/arabulucu/dava-turleri',
                action: ActionsEnum.ArbDavaTurleri
            }
        ],
    }
];
